import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './css';

const PasswordMessage = ({ labels }) => {
  return (
    <Wrapper>
      <span className="frg-body-font-14px">
        <div className="password-validation-wrapper">
          <b>{labels.PASSWORD_GENERAL_MESSAGE}</b>:
          <ul className="password-field">
            <li>{labels.PASWORD_MESSAGE_8_CHARECTER}</li>
            <li>{labels.MIX_NUMBER_LETTERS}</li>
            <li>{labels.SEQUENTIAL_REPEAT}</li>
          </ul>
        </div>
      </span>
    </Wrapper>
  );
};

PasswordMessage.propTypes = {
  labels: PropTypes.objectOf(PropTypes.any).isRequired
};

export default PasswordMessage;
